"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertRoundStateToSerializable = void 0;
const convertRoundStateToSerializable = ({ round, endTs, isRefund, totalBetUp, totalBetDown, totalBetDraw, startValue, endValue, gameState }) => {
    return {
        round,
        endTs,
        isRefund,
        totalBetUp: totalBetUp.toString(),
        totalBetDown: totalBetDown.toString(),
        totalBetDraw: totalBetDraw.toString(),
        startValue: startValue.toString(),
        endValue: endValue.toString(),
        gameState: gameState.toBase58()
    };
};
exports.convertRoundStateToSerializable = convertRoundStateToSerializable;
